
import { defineComponent } from "vue";
import { isExternal } from '@/utils/validate';
export default defineComponent({
    name: 'ALink',
    props: {
        to: {
            type: String,
            required: true
        },
        replace: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        return {
            isExternal
        }
    }
})
